module.exports = __webpack_public_path__ + "img/guide-07.e2aa5313.jpg";